export const TOKEN_KEY = 'kyc_token'

export const hasToken = () => Boolean(localStorage.getItem(TOKEN_KEY))
